<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="secondary" v-b-tooltip.hover :title="showToolTip ? 'Отчет по показаниям' : ''"><i class="fa fa-bar-chart"></i></b-button>
</template>

<script>

export default ({
  name: "button-report-statements",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
